var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.49984C1.5 11.3408 2.99238 12.8332 4.83333 12.8332H12.3333C14.6345 12.8332 16.5 10.9677 16.5 8.6665C16.5 6.36532 14.6345 4.49984 12.3333 4.49984C12.3055 4.49984 12.2778 4.50011 12.2501 4.50065C11.8644 2.59838 10.1828 1.1665 8.16667 1.1665C5.86548 1.1665 4 3.03198 4 5.33317C4 5.64721 4.03474 5.95313 4.10059 6.2473C2.61214 6.58117 1.5 7.91063 1.5 9.49984Z",
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.3a082756a288f0af27aca30171dfa311.svg";
export { ForwardRef as ReactComponent };